import React, { Component } from "react";

import HomePage from "../../pages/home/Home.page";
import AboutUsPage from "../../pages/aboutus/AboutUs.page";
import ProductsPage from "../../pages/products/Products.page";
import ClaimsAxaPage from "../../pages/claimsAxa/claimsAxa.page";
import TermsPage from "../../pages/terms/terms.page";
import PrivacyPolicyPage from "../../pages/privacyPolicy/privacyPolicy";
import ClaimsSBSPage from "../../pages/claimsSBS/claimsSBS.page";
import ClaimsSamsungCarePlusPage from "../../pages/claimsSamsungCarePlus/claimsSamsungCarePlus.page";
import ClaimsPage from "../../pages/claims/ClaimsGeneral.page";
import ClausedPage from "../../pages/claused/claused.page";
import CreateEnelPage from "../../pages/enel/createEnelPage";
import MiCeluPage from "../../pages/micelu/micelu.page";
import VirginPage from "../../pages/virgin/virgin.page";
import AdminRoutesPage from "../../pages/agents/admin/agents-admin.routes.page";
import IcaliPage from "../../pages/icali/icali.page";
import EnelAgentPage from "../../pages/enelAgent/enel.page";
import UnluloPage from "../../pages/unlulo/unlulo.page";
import CellSitePage from "../../pages/cellsite/cellsite.page";
import CelufioPage from "../../pages/celufio/celufio.page";
import CredicellPage from "../../pages/credicell/credicell.page";
import CeluplanetPage from "../../pages/celuplanet/celuplanet.page";
import CelzonePage from "../../pages/cellzone/cellzone.page";
import CredicelexpressPage from "../../pages/credicelexpress/credicelexpress.page";
import SamsungCarePlus from "../../pages/samsungcareplus/samsungcareplus.page";
import IphonerosPage from "../../pages/iphoneros/iphoneros.page";
import PochocellPage from "../../pages/pochocell/pochocell.page";
import OfertacelPage from "../../pages/ofertacel/ofertacel.page";
import MovilexpressPage from "../../pages/movilexpress/movilexpress.page";
import SmartketPage from "../../pages/smartket/smartket.page";
import AlocentralmovilPage from "../../pages/alocentralmovil/alocentralmovil.page";
import ThaniacelPage from "../../pages/thaniacel/thaniacel.page";
import SmartgadgetsPage from "../../pages/smartgadgets/smartgadgets.page";
import EquismobilePage from "../../pages/equismobile/equismobile.page";
import Icali2Page from "../../pages/icali2/icali2.page";
import ToptradingPage from "../../pages/toptrading/toptrading.page";
import GreenelectronicsPage from "../../pages/greenelectronics/greenelectronics.page";
import AcincoPage from "../../pages/acinco/acinco.page";
import KioskoSlugPage from "../../pages/kiosko/kiosko.slug.page";

const routes = [
  {
    path: "/",
    component: HomePage,
    exact: true,
  },
  {
    path: "nosotros",
    component: AboutUsPage,
    exact: true,
  },
  {
    path: "productos",
    component: ProductsPage,
    exact: true,
  },
  {
    path: "tramites-y-reclamaciones",
    component: ClaimsPage,
    exact: true,
  },
  {
    path: "tramites-y-reclamaciones/axa",
    component: ClaimsAxaPage,
    exact: true,
  },
  {
    path: "terminos-y-condiciones",
    component: TermsPage,
    exact: true,
  },
  {
    path: "politica-datos",
    component: PrivacyPolicyPage,
    exact: true,
  },
  {
    path: "tramites-y-reclamaciones/sbs",
    component: ClaimsSBSPage,
    exact: true,
  },
  {
    path: "samsung-care-plus/reclamaciones",
    component: ClaimsSamsungCarePlusPage,
    exact: true,
  },
  {
    path: "clausulados",
    component: ClausedPage,
    exact: true,
  },
  {
    path: "enel",
    component: CreateEnelPage,
    exact: true,
  },
  /* {
    path: "micelu",
    component: MiCeluPage,
    exact: true,
  }, */
  {
    path: "virgin",
    component: VirginPage,
    exact: true,
  },
  {
    path: "icali",
    component: IcaliPage,
    exact: true,
  },
  {
    path: "enel/agent",
    component: EnelAgentPage,
    exact: true,
  },
  { path: "unlulo", component: UnluloPage, exact: true },
  { path: "cellsite", component: CellSitePage, exact: true },
  { path: "celufio", component: CelufioPage, exact: true },
  //{ path: "credicell", component: CredicellPage, exact: true },
  { path: "celuplanet", component: CeluplanetPage, exact: true },
  { path: "cellzone", component: CelzonePage, exact: true },
  { path: "credicelexpress", component: CredicelexpressPage, exact: true },
  { path: "equismobile", component: EquismobilePage, exact: true },
  {
    path: "samsung-care-plus/active/:clientID",
    component: SamsungCarePlus,
    exact: true,
  },
  // { path: "iphoneros", component: IphonerosPage, exact: true },
  // { path: "pochocell", component: PochocellPage, exact: true },
  { path: "ofertacel", component: OfertacelPage, exact: true },
  // { path: "movilexpress", component: MovilexpressPage, exact: true },
  { path: "smartket", component: SmartketPage, exact: true },
  { path: "alocentralmovil", component: AlocentralmovilPage, exact: true },
  { path: "thaniacel", component: ThaniacelPage, exact: true },
  //{ path: "smartgadgets", component: SmartgadgetsPage, exact: true },
  { path: "icali2", component: Icali2Page, exact: true },
  { path: "toptrading", component: ToptradingPage, exact: true },
  //{ path: "greenelectronics", component: GreenelectronicsPage, exact: true },
  { path: "portal", component: AcincoPage, exact: true },
  // Admin dinámico: cualquier kiosko tiene su panel en /{slug}/admin/* sin
  // necesidad de registrarlo en un JSON. Va antes de ":slug" por especificidad.
  { path: ":slug/admin/*", component: AdminRoutesPage, exact: true },
  { path: ":slug", component: KioskoSlugPage, exact: true },
];

export default routes;
